// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3eaS9","content":"LoadingAlert_content__3VP3f"};